"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var api_1 = require("../api");
var item_list_1 = __importDefault(require("./item_list"));
function useSoundList(guildId) {
    var _this = this;
    var _a = (0, react_1.useState)(false), isLoading = _a[0], setIsLoading = _a[1];
    var categories = (0, item_list_1.default)(function (a, b) { return a.id === b.id; });
    var onCompare = function (a, b) { return a.id === b.id; };
    var onFilter = function (filter, sound) {
        var _a;
        return !filter || sound.name.toLowerCase().includes(filter.toLowerCase()) ||
            ((_a = categories.get().find(function (category) { return category.id === sound.categoryId; })) === null || _a === void 0 ? void 0 : _a.name.toLowerCase().includes(filter.toLowerCase()));
    };
    var sounds = (0, item_list_1.default)(onCompare, onFilter);
    var favorites = (0, item_list_1.default)(function (a, b) { return a.soundId === b.soundId; });
    var keybinds = (0, item_list_1.default)(function (a, b) { return a.soundId === b.soundId; });
    var refresh = (0, react_1.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, fetchedCategories, fetchedSounds, fetchedUserFavorites, fetchedUserKeybinds;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!guildId)
                        return [2 /*return*/];
                    setIsLoading(true);
                    return [4 /*yield*/, api_1.api.listCategoriesAndSounds(guildId)];
                case 1:
                    _a = _b.sent(), fetchedCategories = _a[0], fetchedSounds = _a[1];
                    return [4 /*yield*/, api_1.api.listUserFavorites()];
                case 2:
                    fetchedUserFavorites = _b.sent();
                    return [4 /*yield*/, api_1.api.listUserKeybinds()];
                case 3:
                    fetchedUserKeybinds = _b.sent();
                    categories.update.apply(categories, fetchedCategories);
                    sounds.update.apply(sounds, fetchedSounds);
                    favorites.update.apply(favorites, fetchedUserFavorites);
                    keybinds.update.apply(keybinds, fetchedUserKeybinds);
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [guildId]);
    var setFavorite = (0, react_1.useCallback)(function (sound, favorite) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ;
                    if (!!favorite) return [3 /*break*/, 2];
                    return [4 /*yield*/, api_1.api.deleteUserFavorite(sound)];
                case 1:
                    _a.sent();
                    favorites.delete({ userId: 0, soundId: sound.id, created: new Date() });
                    return [2 /*return*/];
                case 2: return [4 /*yield*/, api_1.api.addUserFavorite(sound)];
                case 3:
                    _a.sent();
                    favorites.update({ userId: 0, soundId: sound.id, created: new Date() });
                    return [2 /*return*/];
            }
        });
    }); }, [guildId, favorites]);
    var setKeybind = (0, react_1.useCallback)(function (sound, key) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ;
                    if (!(key === null || key === '')) return [3 /*break*/, 2];
                    return [4 /*yield*/, api_1.api.deleteUserKeybindForSound(sound)];
                case 1:
                    _a.sent();
                    keybinds.delete({ userId: 0, soundId: sound.id, key: '', created: new Date() });
                    return [2 /*return*/];
                case 2: return [4 /*yield*/, api_1.api.deleteUserKeybindForKey(key)];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, api_1.api.addUserKeybind(sound, key)];
                case 4:
                    _a.sent();
                    keybinds.update.apply(keybinds, __spreadArray([{ userId: 0, soundId: sound.id, key: key, created: new Date() }], keybinds.get().flatMap(function (keybind) { return keybind.key === key ? [__assign(__assign({}, keybind), { key: null })] : []; }), false));
                    return [2 /*return*/];
            }
        });
    }); }, [guildId, keybinds]);
    (0, react_1.useEffect)(function () {
        refresh();
    }, [guildId]);
    return {
        isLoading: isLoading,
        categories: categories,
        sounds: sounds,
        favorites: favorites,
        keybinds: keybinds,
        refresh: refresh,
        setFavorite: setFavorite,
        setKeybind: setKeybind
    };
}
exports.default = useSoundList;
